module.exports = __webpack_public_path__ + "static/fonts/Mont-SemiBold.8263612.eot";